module.exports = __webpack_public_path__ + "assets/emptyList.b8f09d43.svg";